import { AbstractLinkModel, isNullOrUndefined } from '@uzurv/core';
import { autoserialize, autoserializeAs } from 'cerialize';
import { RideSharingService } from './ride-sharing-service';

/**
 * Verify this is deprecated
 *
 * @deprecated
 */
export class DriverRideSharingService extends AbstractLinkModel {
  @autoserialize
  driverId: number;

  @autoserializeAs(RideSharingService)
  rideSharingService: RideSharingService;

  @autoserialize
  approved: boolean;

  @autoserializeAs(Date)
  approvalDate: Date;

  @autoserialize
  rideSharingServiceDriverIdentifier: string;

  @autoserialize
  rideSharingServiceProfileScreenshot: string;

  static OnSerialized(instance: DriverRideSharingService, json: any): void {
    super.OnSerialized(instance, json);

    if (!isNullOrUndefined(instance.approvalDate)) {
      json.approvalDate = instance.approvalDate.getTime();
    }
  }

  static OnDeserialized(instance: DriverRideSharingService, json: any): void {
    super.OnDeserialized(instance, json);

    if (!isNullOrUndefined(json['approvalDate'])) {
      instance.approvalDate = new Date(json['approvalDate']);
    }
  }
}
